module.exports = __webpack_public_path__ + "img/instant-response.c137a42f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_logos/instant-response.png
// module id = ySv/
// module chunks = 0